import React, {useState} from "react";
import {Dropdown} from "react-bootstrap";
import DropdownToggle from "react-bootstrap/esm/DropdownToggle";
import DropdownMenu from "react-bootstrap/esm/DropdownMenu";

function CustomSelectDropdown({
  sectorCategories,
  selectedCategory,
  setSelectedCategory,
  disabled,
  IsSubCategory,
}) {
  const [isOpen, setIsOpen] = useState(false);

  const handleToggle = (isOpen) => {
    if (!!disabled) {
      return;
    }
    setIsOpen(isOpen);
  };

  const handleItemClick = (category) => {
    setSelectedCategory(category);
    setIsOpen(false); // Close the dropdown
  };

  return (
    <Dropdown show={isOpen} onToggle={handleToggle}>
      <DropdownToggle variant="" className="i-false !p-0 w-full">
        <div className="flex items-center font-normal text-xs sm:text-sm text-[#333333] justify-between w-full !p-4 border rounded-lg border-solid border-[#E2E2E2] overflow-x-hidden">
          <div className="flex-grow truncate text-left">
            {selectedCategory?.title ??
              (!!IsSubCategory
                ? "Choisir une ou plusieurs sous-catégories"
                : "Choisir une catégorie")}
          </div>
          <i className="fi fi-rr-angle-small-down flex items-center"></i>
        </div>
      </DropdownToggle>
      <DropdownMenu
        align="left"
        className="w-full p-0 !rounded-md max-h-[400px] !overflow-y-scroll overflow-style-none"
      >
        {!!sectorCategories?.length &&
          sectorCategories?.map((category) => (
            <div
              className="flex items-center gap-2 cursor-pointer p-2 border-b text-[#333333] font-normal text-sm hover:text-[#FF6600] hover:bg-[#EFF2F7]"
              key={category.id}
              onClick={() => handleItemClick(category)}
            >
              {category.title}
            </div>
          ))}
      </DropdownMenu>
    </Dropdown>
  );
}

export default CustomSelectDropdown;
